module.exports = " <div class=email-display> <div class=row> <label class=\"col-sm-4 control-label\">{{ field.label }}</label> <div class=col-sm-8><a v-bind:href=\"'mailto:' + field.value\">{{ field.value }}</a></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/displays/EmailDisplay.vue
// module id = 707
// module chunks = 2